import { theme } from 'lib';
import styled from 'styled-components';

const Badge = styled.div`
  height: 23px;
  padding: 0 5px;
  min-width: 23px;
  display: flex;
  justify-content: center;
  font-weight: bold;
  align-items: center;
  border-radius: 5px;
  color: white;
  font-size: 12px;
  ${(props) => props.absolute && 'position: absolute;'}
  background: ${(props) => (props.orange ? theme.ORANGE : theme.BLUE)};
`;

export default Badge;
